/**
 * useEmployeeDocumentMasterEntryScreen.js
 * ---------------------------------------
 * Hook for Employee Document Master create/edit form screen using shared useMasterEntry.
 */
import { useState, useEffect } from 'react';
import { useMasterEntry } from '../../common/useMasterEntry';
import * as employeeDocumentMasterApi from '../api/employeeDocumentMasterApi';

export function useEmployeeDocumentMasterEntryScreen() {
  const [categories, setCategories] = useState([]);
  const [tokens, setTokens] = useState([]);

  useEffect(() => {
    async function loadMeta() {
      try {
        const [cats, tks] = await Promise.all([
          employeeDocumentMasterApi.getDocumentCategories(),
          employeeDocumentMasterApi.getAvailableTokens(),
        ]);
        setCategories(cats || []);
        setTokens(tks || []);
      } catch (err) {
        console.error('Failed to load document metadata:', err);
      }
    }
    loadMeta();
  }, []);

  const master = useMasterEntry({
    entityName: 'Employee Document Template',
    apiClient: employeeDocumentMasterApi.employeeDocumentMasterClient,
    fetchDetail: employeeDocumentMasterApi.getDocumentTemplateDetail,
    createItem: employeeDocumentMasterApi.createDocumentTemplate,
    updateItem: employeeDocumentMasterApi.updateDocumentTemplate,
    initialForm: {
      name: '',
      cat_id: '',
      content: '',
    },
    validate: (form) => {
      if (!form.name || !form.name.trim()) {
        return 'Template Name is required.';
      }
      return null;
    },
    listPath: '/masters/employee-document-master/list',
    transformPayload: (form, operationalStatus) => ({
      name: form.name.trim(),
      cat_id: form.cat_id ? Number(form.cat_id) : null,
      content: form.content || '',
      status: operationalStatus === 'active' ? 'Active' : 'Archived',
    }),
    transformDetail: (detail) => ({
      form: {
        name: detail.name || '',
        cat_id: detail.cat_id ? String(detail.cat_id) : '',
        content: detail.content || '',
      },
      operationalStatus: detail.status === 'Active' ? 'active' : 'inactive',
    }),
  });

  const insertToken = (token) => {
    const current = master.state.form.content || '';
    const updated = current ? `${current} ${token}` : token;
    master.actions.patchForm('content', updated);
  };

  return {
    ...master,
    state: {
      ...master.state,
      categories,
      tokens,
    },
    actions: {
      ...master.actions,
      insertToken,
    },
  };
}
